/**
 * Returns CSS classes for change indicator based on the change value
 * Uses three-way conditional logic: positive, zero, negative
 * @param change - The change value (positive, zero, or negative)
 * @returns CSS classes for background and text color
 */
export const getChangeIndicatorClasses = (change: number): string => {
  if (change > 0) return 'bg-emerald-100 text-emerald-800';
  if (change === 0) return 'bg-gray-100 text-gray-900';
  return 'bg-red-100 text-red-800';
};

/**
 * Returns the appropriate arrow icon color class for change indicators
 * @param change - The change value
 * @returns CSS class for icon color
 */
export const getChangeArrowIconColor = (change: number): string => {
  if (change > 0) return 'text-emerald-500';
  if (change < 0) return 'text-red-500';
  return ''; // No color for zero change
};
